import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';

export interface MessageSnackBarData {
  label: string;
  action: string;
  onAction: () => void;
}

@Component({
  selector: 'message-snackbar',
  templateUrl: './message-snackbar.component.html',
  styles: [
    `
      :host {
        display: flex;
      }

      .action {
        color: #abc7ff !important;
      }
    `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatSnackBarModule],
})
export class MessageSnackbarComponent {
  readonly data = inject<MessageSnackBarData>(MAT_SNACK_BAR_DATA);
}
